// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__uE2ja","blog__link":"styles_blog__link__aUHtg","item":"styles_item__l79rH","item__in":"styles_item__in__o3K5n"};